module.exports = __webpack_public_path__ + "img/tab-create-active.2a5c4f0.png";